import script from "./AppsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppsList.vue?vue&type=script&setup=true&lang=js"

import "./AppsList.vue?vue&type=style&index=0&id=7c884512&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c884512"]])

export default __exports__